import { render, staticRenderFns } from "./ListLight.vue?vue&type=template&id=0417c1c2&"
import script from "./ListLight.vue?vue&type=script&lang=ts&"
export * from "./ListLight.vue?vue&type=script&lang=ts&"
import style0 from "./ListLight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports